import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NewSidebareCommercial } from "../../NewSideBareCommercial";
import axios from "axios";

/* ── FAQ data (FR & AR) ── */
const FAQ_FR = [
  {
    q: "Comment ajouter un produit au panier ?",
    a: "Sur la page d'accueil ou la liste des articles, cliquez sur le bouton 🛒 « Ajouter au panier » sous le produit souhaité. Vous pouvez modifier la quantité avant de l'ajouter.",
  },
  {
    q: "Comment changer mon email ?",
    a: "Rendez-vous dans ⚙️ Paramètres > Sécurité > « Changer l'adresse email ». Saisissez votre nouvelle adresse et envoyez la demande. L'administrateur la validera sous 24h.",
  },
  {
    q: "Comment changer mon mot de passe ?",
    a: "Allez dans ⚙️ Paramètres > Sécurité > « Changer le mot de passe ». Saisissez votre nouveau mot de passe et soumettez la demande pour validation par l'admin.",
  },
  {
    q: "Comment consulter mon historique de commandes ?",
    a: "Dans le menu latéral, cliquez sur 📋 Historique. Vous y trouverez toutes vos commandes avec leur statut (Confirmé, Remboursé, Annulé).",
  },
  {
    q: "Comment voir mon solde disponible ?",
    a: "Votre solde est affiché sur la page d'accueil (carte de fidélité) et dans ⚙️ Paramètres > Informations du compte.",
  },
  {
    q: "Comment passer une commande ?",
    a: "Ajoutez les articles souhaités au panier, puis cliquez sur l'icône 🛒 en bas à droite, vérifiez votre panier et confirmez la commande.",
  },
];

const FAQ_AR = [
  {
    q: "كيفية إضافة منتج إلى السلة؟",
    a: "في الصفحة الرئيسية أو قائمة المقالات، انقر على زر 🛒 «إضافة إلى السلة» أسفل المنتج المطلوب. يمكنك تعديل الكمية قبل الإضافة.",
  },
  {
    q: "كيف أغير بريدي الإلكتروني؟",
    a: "انتقل إلى ⚙️ الإعدادات > الأمان > «تغيير البريد الإلكتروني». أدخل عنوانك الجديد وأرسل الطلب. سيقوم المسؤول بالموافقة خلال 24 ساعة.",
  },
  {
    q: "كيف أغير كلمة المرور؟",
    a: "انتقل إلى ⚙️ الإعدادات > الأمان > «تغيير كلمة المرور». أدخل كلمة المرور الجديدة وأرسل الطلب للموافقة من المشرف.",
  },
  {
    q: "كيف أتصفح سجل طلباتي؟",
    a: "في القائمة الجانبية، انقر على 📋 السجل. ستجد جميع طلباتك مع حالتها (مؤكد، مُسترد، ملغى).",
  },
  {
    q: "كيف أرى رصيدي المتاح؟",
    a: "يظهر رصيدك في الصفحة الرئيسية (بطاقة الولاء) وفي ⚙️ الإعدادات > معلومات الحساب.",
  },
  {
    q: "كيف أقدم طلباً؟",
    a: "أضف المقالات المطلوبة إلى السلة، ثم انقر على أيقونة 🛒 في أسفل اليمين، راجع سلتك وأكد الطلب.",
  },
];

type Lang = "fr" | "ar";

export default function AssistanceCommercial() {
  const CommercialName = localStorage.getItem("CommercialName") ?? "Commercial";
  const CommercialId = localStorage.getItem("CommercialId") ?? "";
  const navigate = useNavigate();

  const [lang, setLang] = useState<Lang>("fr");
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  const [showAutre, setShowAutre] = useState(false);
  const [autreMsg, setAutreMsg] = useState("");
  const [sending, setSending] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [sendError, setSendError] = useState("");
  const [emptyError, setEmptyError] = useState(false);

  const faq = lang === "fr" ? FAQ_FR : FAQ_AR;
  const isAr = lang === "ar";

  const handleSendAutre = async () => {
    if (!autreMsg.trim()) {
      setEmptyError(true);
      setTimeout(() => setEmptyError(false), 3000);
      return;
    }
    setSending(true);
    setSendError("");
    setEmptyError(false);
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/commercial/${CommercialId}/send-message`, {
        message: autreMsg,
        commercialName: CommercialName,
      });
      setAutreMsg("");
      setShowSuccessPopup(true);
      setTimeout(() => {
        setShowSuccessPopup(false);
        navigate(`/commercials/${CommercialId}`);
      }, 2500);
    } catch {
      setSendError(isAr ? "خطأ في الإرسال، حاول مرة أخرى." : "Erreur lors de l'envoi, veuillez réessayer.");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <NewSidebareCommercial />
      <div style={{ fontFamily: "'Inter', sans-serif", minHeight: "100vh", background: "#F8FAFC", paddingBottom: "80px" }}>
        <div style={{ marginLeft: "240px", padding: "32px 36px", maxWidth: "760px", transition: "margin-left 0.3s" }}>

          {/* Back */}
          <button onClick={() => window.history.back()} style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "10px 18px", borderRadius: "12px", border: "1.5px solid #E2E8F0", background: "#fff", color: "#334155", fontSize: "0.85rem", fontWeight: 600, cursor: "pointer", marginBottom: "24px" }}>
            ← {isAr ? "رجوع" : "Retour"}
          </button>

          {/* Header */}
          <div style={{ background: "linear-gradient(135deg,#1E293B,#0F172A)", borderRadius: "20px 20px 0 0", padding: "24px 28px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <h2 style={{ color: "#fff", margin: 0, fontWeight: 700, fontSize: "1.1rem", display: "flex", alignItems: "center", gap: "8px" }}>
                <i className="bi bi-headset" style={{ color: "#F5A623" }}></i>
                {isAr ? "مركز المساعدة" : "Centre d'assistance"}
              </h2>
              <span style={{ color: "#94A3B8", fontSize: "0.78rem", display: "flex", alignItems: "center", gap: "6px", marginTop: "6px" }}>
                <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#10B981", display: "inline-block" }}></span>
                {isAr ? "متاح دائماً" : "Toujours disponible"}
              </span>
            </div>
            {/* Language toggle */}
            <div style={{ display: "flex", gap: "8px" }}>
              {(["fr", "ar"] as Lang[]).map((l) => (
                <button key={l} onClick={() => setLang(l)} style={{ padding: "6px 16px", borderRadius: "20px", border: "none", cursor: "pointer", fontWeight: 700, fontSize: "0.82rem", background: lang === l ? "#F5A623" : "rgba(255,255,255,0.1)", color: lang === l ? "#1a1a2e" : "#fff", transition: "all 0.2s" }}>
                  {l === "fr" ? "🇫🇷 FR" : "🇲🇦 AR"}
                </button>
              ))}
            </div>
          </div>

          {/* Body */}
          <div style={{ background: "#fff", border: "1.5px solid #E2E8F0", borderTop: "none", borderRadius: "0 0 20px 20px", padding: "28px" }}>

            <p style={{ fontSize: "0.9rem", color: "#64748b", marginBottom: "24px", direction: isAr ? "rtl" : "ltr" }}>
              {isAr
                ? `مرحباً ${CommercialName}، كيف يمكننا مساعدتك اليوم؟`
                : `Bonjour ${CommercialName}, comment pouvons-nous vous aider aujourd'hui ?`}
            </p>

            {/* FAQ Accordion */}
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "28px", direction: isAr ? "rtl" : "ltr" }}>
              {faq.map((item, i) => (
                <div key={i} style={{ border: "1.5px solid #E2E8F0", borderRadius: "12px", overflow: "hidden", transition: "all 0.2s" }}>
                  <button
                    onClick={() => setOpenIdx(openIdx === i ? null : i)}
                    style={{ width: "100%", padding: "14px 18px", background: openIdx === i ? "#FFF8E7" : "#fff", border: "none", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", textAlign: isAr ? "right" : "left", gap: "12px" }}
                  >
                    <span style={{ fontWeight: 600, fontSize: "0.9rem", color: "#1e293b", flex: 1 }}>
                      <i className="bi bi-question-circle" style={{ color: "#F5A623", marginRight: isAr ? 0 : "8px", marginLeft: isAr ? "8px" : 0 }}></i>
                      {item.q}
                    </span>
                    <i className={`bi bi-chevron-${openIdx === i ? "up" : "down"}`} style={{ color: "#F5A623", fontSize: "0.8rem", flexShrink: 0 }}></i>
                  </button>
                  {openIdx === i && (
                    <div style={{ padding: "14px 18px 16px", background: "#FFFDF5", borderTop: "1px solid #FEF3C7", fontSize: "0.88rem", color: "#334155", lineHeight: 1.7 }}>
                      {item.a}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Autre button */}
            {!showAutre ? (
              <button
                onClick={() => setShowAutre(true)}
                style={{ width: "100%", padding: "14px", borderRadius: "12px", border: "2px dashed #E2E8F0", background: "#F8FAFC", cursor: "pointer", fontSize: "0.9rem", fontWeight: 600, color: "#64748b", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", transition: "all 0.2s", direction: isAr ? "rtl" : "ltr" }}
                onMouseOver={(e) => { e.currentTarget.style.borderColor = "#F5A623"; e.currentTarget.style.color = "#F5A623"; }}
                onMouseOut={(e) => { e.currentTarget.style.borderColor = "#E2E8F0"; e.currentTarget.style.color = "#64748b"; }}
              >
                <i className="bi bi-envelope-plus"></i>
                {isAr ? " سؤال آخر — أرسل رسالة للمتجر" : " Autre — Envoyer un message à mon magasin"}
              </button>
            ) : (
              <div style={{ border: "1.5px solid #F5A623", borderRadius: "16px", padding: "20px", background: "#FFFDF5", direction: isAr ? "rtl" : "ltr" }}>
                <h4 style={{ margin: "0 0 16px", fontSize: "0.95rem", fontWeight: 700, color: "#1e293b", display: "flex", alignItems: "center", gap: "8px" }}>
                  <i className="bi bi-envelope" style={{ color: "#F5A623" }}></i>
                  {isAr ? "إرسال رسالة إلى المتجر" : "Envoyer un message à votre magasin"}
                </h4>

                {emptyError && (
                  <div style={{ padding: "10px 14px", borderRadius: "8px", background: "#fee2e2", color: "#b91c1c", fontSize: "0.85rem", fontWeight: 600, marginBottom: "12px", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="bi bi-exclamation-circle-fill"></i>
                    {isAr ? "يرجى كتابة رسالة قبل الإرسال." : "Veuillez écrire un message avant d'envoyer."}
                  </div>
                )}

                {sendError && (
                  <div style={{ padding: "10px 14px", borderRadius: "8px", background: "#fee2e2", color: "#b91c1c", fontSize: "0.85rem", fontWeight: 600, marginBottom: "12px", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="bi bi-exclamation-circle-fill"></i>
                    {sendError}
                  </div>
                )}

                <textarea
                  value={autreMsg}
                  onChange={(e) => { setAutreMsg(e.target.value); if (emptyError) setEmptyError(false); }}
                  rows={5}
                  placeholder={isAr ? "اكتب رسالتك هنا..." : "Écrivez votre message ici..."}
                  style={{ width: "100%", padding: "12px 14px", border: emptyError ? "1.5px solid #f87171" : "1.5px solid #E2E8F0", borderRadius: "10px", fontSize: "0.88rem", resize: "vertical", fontFamily: "'Inter', sans-serif",color:"black", outline: "none", boxSizing: "border-box", marginBottom: "14px", display: "block", background: "#fff" }}
                  onFocus={(e) => (e.target.style.borderColor = "#F5A623")}
                  onBlur={(e) => (e.target.style.borderColor = emptyError ? "#f87171" : "#E2E8F0")}
                />

                <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                  <button onClick={() => { setShowAutre(false); setAutreMsg(""); setSendError(""); setEmptyError(false); }} style={{ padding: "9px 20px", borderRadius: "8px", border: "1.5px solid #e2e8f0", background: "#f8fafc", color: "#64748b", fontWeight: 600, cursor: "pointer", fontSize: "0.88rem" }}>
                    {isAr ? "إلغاء" : "Annuler"}
                  </button>
                  <button onClick={handleSendAutre} disabled={sending} style={{ padding: "9px 20px", borderRadius: "8px", border: "none", background: "#F5A623", color: "#1a1a2e", fontWeight: 700, cursor: sending ? "not-allowed" : "pointer", fontSize: "0.88rem", opacity: sending ? 0.6 : 1, display: "flex", alignItems: "center", gap: "6px" }}>
                    {sending ? <><span className="spinner-border spinner-border-sm" style={{ width: "14px", height: "14px", borderWidth: "2px" }} /> {isAr ? "جاري الإرسال..." : "Envoi..."}</> : <><i className="bi bi-send-fill"></i> {isAr ? "إرسال" : "Envoyer"}</>}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ── Success Popup ── */}
      {showSuccessPopup && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 9999, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div style={{ background: "#fff", borderRadius: "20px", padding: "40px 36px", textAlign: "center", boxShadow: "0 12px 48px rgba(0,0,0,0.2)", maxWidth: "340px", width: "90%", animation: "popupIn 0.3s ease" }}>
            <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "linear-gradient(135deg,#F5A623,#e8930c)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px", fontSize: "1.8rem" }}>
              ✅
            </div>
            <h3 style={{ margin: "0 0 10px", fontSize: "1.15rem", fontWeight: 800, color: "#1e293b" }}>
              {isAr ? "تم الإرسال بنجاح!" : "Message envoyé !"}
            </h3>
            <p style={{ margin: 0, fontSize: "0.88rem", color: "#64748b", lineHeight: 1.6 }}>
              {isAr ? "تم إرسال رسالتك إلى المتجر بنجاح." : "Votre message a bien été envoyé à votre magasin."}
            </p>
          </div>
        </div>
      )}

      <style>{`
        @keyframes popupIn { from { opacity: 0; transform: scale(0.85); } to { opacity: 1; transform: scale(1); } }
        @media (max-width: 768px) {
          div[style*="margin-left: 240px"] {
            margin-left: 0 !important;
            padding: 16px 14px 90px !important;
            padding-top: 62px !important;
          }
        }
      `}</style>
    </>
  );
}